<template>
  <div class="table-simple">
    <b-table-simple bordered responsive>
      <b-thead>
        <b-tr>
          <!-- <b-th class="text-white">Customer Name</b-th>
                    <b-th class="text-white">{{ customer.name }}</b-th> -->
          <b-th class="text-white">Period</b-th>
          <b-th class="text-white">Column</b-th>
          <b-th class="text-white">Interest Charged(RM)</b-th>
          <b-th class="text-white">Principal(RM)</b-th>
          <b-th class="text-white">Installment(RM)</b-th>
          <b-th class="text-white">Balance(RM)</b-th>
        </b-tr>
      </b-thead>
      <b-tbody v-if="!_gHlp.isEmpty(loans)">
        <b-tr v-for="loan in loans" :key="loan.period">
          <b-td>{{ loan.period }}</b-td>
          <b-td>{{ loan.column }}</b-td>
          <b-td>{{ loan.interest_charged | moneyFormatter }}</b-td>
          <b-td>{{ loan.principal | moneyFormatter }}</b-td>
          <b-td>{{ loan.installment | moneyFormatter }}</b-td>
          <b-td>{{ loan.balance | moneyFormatter }}</b-td>
        </b-tr>
      </b-tbody>
			<b-tbody v-else>
        <b-tr>
					<b-td colspan="6">No Record</b-td>
				</b-tr>
			</b-tbody>
    </b-table-simple>
  </div>
</template>
<script>
import { Table, TableColumn } from 'element-ui'
export default {
  props: ['loan-table'],
  name: 'table-loan',
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data() {
    return {
      loans: this.loanTable
    }
  },
}
</script>